module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp2_9005.598bb601.png";